import { ACCESSIBILITY_PATH } from "./accessibility";
import {
  ADDRESS_LINES,
  DISCORD_INVITE_URL,
  SUPPORT_EMAIL,
  SUPPORT_EMAIL_HREF,
  SUPPORT_PHONE,
  SUPPORT_PHONE_HREF,
} from "./contact";
import { KNITTING_PATH, PRIVACY_URL, TERMS_URL } from "./nav";
import { TRADEMARK, type Copy } from "./types";

export type FooterLink = {
  readonly label: string;
  readonly href: string;
  readonly external: boolean;
};

export type FooterColumn = {
  readonly id: string;
  readonly heading: string;
  readonly links: readonly FooterLink[];
};

export const FOOTER_CLAIM = "We are establishing a new method of making — faster, smarter, better.";

export const FOOTER_COLUMNS: readonly FooterColumn[] = [
  {
    id: "product",
    heading: "Product",
    links: [
      { label: "How it works", href: "#how", external: false },
      { label: "Applications", href: "#applications", external: false },
      { label: "Platform", href: "#platform", external: false },
      { label: "3D knitting, in action", href: KNITTING_PATH, external: false },
      { label: "Pricing", href: "/start", external: false },
    ],
  },
  {
    id: "contact",
    heading: "Contact",
    links: [
      { label: SUPPORT_EMAIL, href: SUPPORT_EMAIL_HREF, external: false },
      { label: SUPPORT_PHONE, href: SUPPORT_PHONE_HREF, external: false },
    ],
  },

  {
    id: "legal",
    heading: "Legal",
    links: [
      { label: "Terms of Service", href: TERMS_URL, external: true },
      { label: "Privacy Policy", href: PRIVACY_URL, external: true },
      { label: "Accessibility", href: ACCESSIBILITY_PATH, external: false },
    ],
  },
  {
    id: "follow",
    heading: "Follow",
    links: [
      { label: "Instagram", href: "https://www.instagram.com/variant3d/", external: true },
      { label: "LinkedIn", href: "https://www.linkedin.com/company/variant-3d", external: true },
      { label: "YouTube", href: "https://www.youtube.com/channel/UCfSZVt3wni2DbOwgmES8hIA", external: true },
      { label: "Discord", href: DISCORD_INVITE_URL, external: true },
    ],
  },
];

export const FOOTER_ADDRESS = ADDRESS_LINES;

export const FOOTER_COPYRIGHT_SUFFIX = "VARIANT3D. All rights reserved.";

export const FOOTER_TAGLINE: Copy = ["LOOP", TRADEMARK, " — software that knits."];
